import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { useNavigationContext } from 'Components/ComponentLibrary/Organisms/NavigationWithContext/NavigationContext';
import Navigation from 'Components/ComponentLibrary/Organisms/Navigation';

const NavigationPicker = () => {
  const {
    navigationCollection,
    isInitializing,
    navigationLoadingError,
    open,
    pageResource,
  } = useNavigationContext();

  return pickFunction(pageResource, {
    [fr.relationships.navigation.name]: () => {
      return (
      /* Wrap Context needed globally by all navigations here */
        <Navigation
          collection={navigationCollection}
          isInitializing={isInitializing}
          loadingError={navigationLoadingError}
          open={open}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default NavigationPicker;
